import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { GetItemRouteResponse } from "@apiserver-rest/ponder-data-client-base";
import { NavigationService } from "@ponder-core/navigation/navigation.service";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";

@Component({
    imports: [LoadingComponent],
    templateUrl: "./item.component.html"
})
export class ItemComponent {
    @Input() public itemId!: string;

    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;

    constructor(private ponderDataClient: PonderDataClient, private navigation: NavigationService) {

    }

    public ngOnInit(): void {
        this.ponderDataClient.itemRoute(this.itemId).subscribe({
            next: (response: GetItemRouteResponse) => {
                if (response.success && response.url) {
                    this.loadingSuccess = true;
                    this.navigation.goto(response.url);
                }
            }
        }).add(() => { this.isLoading = false; });
    }
}